export default __webpack_public_path__ + "static/media/mas-logo.b248e225.svg";